var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteWarning({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.30237 3.74316C9.04703 2.41931 10.9532 2.41931 11.6979 3.74316L17.8297 14.6445C18.5601 15.9429 17.6221 17.5477 16.1324 17.5479H3.8678C2.37805 17.5479 1.4392 15.943 2.16956 14.6445L8.30237 3.74316ZM9.99963 13.1523C9.25475 13.1525 8.651 13.7561 8.651 14.501C8.65104 15.2459 9.25478 15.8495 9.99963 15.8496C10.7446 15.8496 11.3492 15.2459 11.3492 14.501C11.3492 13.756 10.7446 13.1523 9.99963 13.1523ZM9.99963 5.45996C9.25475 5.46009 8.651 6.06368 8.651 6.80859V10.1055C8.65113 10.8503 9.25483 11.454 9.99963 11.4541C10.7445 11.4541 11.3491 10.8503 11.3492 10.1055V6.80859C11.3492 6.06361 10.7446 5.45996 9.99963 5.45996Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteWarning);
export default __webpack_public_path__ + "static/media/white-warning.c2b8efec29c109d6952688e5984bb0cf.svg";
export { ForwardRef as ReactComponent };